/* Testing helper: keeps ?fs=live (or teaser/urgent/closed/ended) while you browse.
   Add ?fs=off to any URL to stop previewing. Has no effect for normal visitors. */
(function () {
  try {
    var url = new URL(window.location.href);
    var q = url.searchParams.get('fs');
    if (q === 'off') {
      sessionStorage.removeItem('fsPreview');
      url.searchParams.delete('fs');
      history.replaceState(null, '', url.toString());
      return;
    }
    if (q) {
      sessionStorage.setItem('fsPreview', q);
      return;
    }
    var saved = sessionStorage.getItem('fsPreview');
    if (saved) {
      url.searchParams.set('fs', saved);
      history.replaceState(null, '', url.toString());
    }
  } catch (e) {}
})();
